import type { IOneVerifyPayerStatus } from "@common-shared/types/responseData/oneVerifyResponseData.types"

import { API_ROUTES } from "../config/routes.config"
import { HttpHelper } from "../helpers/http.helper"
import { UtilHelper } from "../helpers/util.helper"

export class PayerStatusService {
    /**
     * Get payers statuses and their incidents from payers monitor
     */
    static async getPayerStatus(): Promise<IOneVerifyPayerStatus | null> {
        const result = await HttpHelper.sendRequest(
            API_ROUTES.PAYER_STATUS_GET,
            {},
            "GET",
            undefined,
            undefined,
            undefined,
            // Page shows its own error, toast would repeat on every refresh
            [500, 502, 503, 504],
        )

        return !UtilHelper.isEmptyObject(result) && !result.errorData
            ? result
            : null
    }
}
